module.exports = "/assets/b10270262386d60764924ea68d52d466.svg";